// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1770628936406
      var cssReload = require("D:/work/admin/atmolab_server_manage/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  